import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Spin } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { FaArrowRight } from "react-icons/fa6";
import CommonService from "@/services/api/CommonService";

const { Option } = Select;

const genderOptions = [
  { label: "ছেলে", value: "male" },
  { label: "মেয়ে", value: "female" },
];

const RegisterStepForm = ({ onSubmit }) => {
  const [classOptions, setClassOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [classes, groups] = await Promise.all([
          CommonService.getAllClasses(),
          CommonService.getAllGroups(),
        ]);

        setClassOptions(
          (classes || []).map((cls) => ({
            value: cls.id,
            label: cls.title,
          }))
        );
        setGroupOptions(
          (groups || []).map((grp) => ({
            value: grp.id,
            label: grp.name,
          }))
        );
      } catch (error) {
        console.error("Error loading class/group options", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "200px",
          width: "100%",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      <h2 className="second-title">ফোকাসে স্বাগতম আপনাকে</h2>
      <Form layout="vertical" onFinish={onSubmit} className="login-reg-form">
        <Form.Item name="name" rules={[{ required: true, message: "নাম দাও" }]}>
          <Input size="large" placeholder="নাম" className="rounded" />
        </Form.Item>

        <Form.Item
          name="class_id"
          rules={[{ required: true, message: "আপনার ক্লাস নির্বাচন করো" }]}
        >
          <Select
            showSearch
            size="large"
            placeholder="ক্লাস নির্বাচন করো"
            optionFilterProp="label"
            autoComplete="off"
            className="rounded"
          >
            {classOptions.map(({ value, label }) => (
              <Option key={value} value={value} label={label}>
                {label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="group_id"
          // rules={[{ required: true, message: "আপনার বিভাগ নির্বাচন করো" }]}
        >
          <Select
            showSearch
            size="large"
            placeholder="বিভাগ নির্বাচন করো"
            optionFilterProp="label"
            autoComplete="off"
            className="rounded"
          >
            {groupOptions.map(({ value, label }) => (
              <Option key={value} value={value} label={label}>
                {label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="gender"
          rules={[{ required: true, message: "লিঙ্গ নির্বাচন করো" }]}
        >
          <Select
            showSearch
            size="large"
            placeholder="লিঙ্গ নির্বাচন করো"
            optionFilterProp="label"
            className="rounded"
          >
            {genderOptions.map(({ value, label }) => (
              <Option key={value} value={value} label={label}>
                {label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: "পাসওয়ার্ড দিন" }]}
          hasFeedback
        >
          <Input.Password
            size="large"
            placeholder="পাসওয়ার্ড"
            className="rounded"
            iconRender={(visible) =>
              visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          dependencies={["password"]}
          hasFeedback
          rules={[
            { required: true, message: "পাসওয়ার্ড নিশ্চিত করো" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("পাসওয়ার্ড মিলছে না"));
              },
            }),
          ]}
        >
          <Input.Password
            size="large"
            placeholder="পাসওয়ার্ড নিশ্চিত করো"
            className="rounded"
            iconRender={(visible) =>
              visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          size="large"
          className="login-regictation-submit-btn"
        >
          সাবমিট করো <FaArrowRight />
        </Button>
      </Form>
    </>
  );
};

export default RegisterStepForm;
